import React from 'react';
import './AnnouncementCard.css';
import Chip from '@mui/material/Chip';
import TimeZoneHandler from '../../../../handlers/TimeZoneHandler';

const AnnouncementCard = ({ announcement, onClick, topicName }) => {
    const convertCreatedAt = (value) => {
        try {
            return TimeZoneHandler.convertTime(value);
        } catch (e) {
            return value;
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    };

    const formatTime = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const createdAtLocal = convertCreatedAt(announcement?.created_at);

    return (
        <div className="announcement-card" onClick={onClick}>
            <div className="announcement-card-header">
                <div className="announcement-card-header-left">
                    <Chip
                        label={topicName || announcement.topic || 'General'}
                        size="small"
                        className="announcement-card-chip"
                        sx={{
                            backgroundColor: '#9b59b6',
                            color: '#fff',
                            textTransform: 'capitalize',
                        }}
                    />
                    <h3 className="announcement-card-title">
                        {announcement.announcement_title || 'Untitled'}
                    </h3>
                </div>
                <div className="announcement-card-time">
                    <span>{formatDate(createdAtLocal)}</span>
                    <span className="separator">•</span>
                    <span>{formatTime(createdAtLocal)}</span>
                </div>
            </div>

            <p className="announcement-card-description">
                {announcement.announcement_body}
            </p>
        </div>
    );
};

export default AnnouncementCard;